// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3p5Mr","rootSuccess":"CompleteLink_rootSuccess__3eHc0","rootFailure":"CompleteLink_rootFailure__IqDTI","isDisabled":"CompleteLink_isDisabled__S4zTs"};